<template lang="pug">
  .buttons
    .btn
      el-button(
        type="default",
        @click="voltarAba",
        name="voltar"
        v-show="(isDae || !isPrimeiroPasso) && showButtonVoltar"
      )
        span.center
          i.fas.fa-chevron-left
          b &nbsp Voltar
      el-button(
        @click="cancelar",
        name="cancelar"
        class="cancelarButton"
        v-show="showButtonCancelar && !isIntroPasso"
      )
        span.center
          i.fas.fa-times
          b &nbsp {{ cancelarLabel }}
      el-button(
        @click="changeAnalise",
        name="analiseManual"
        v-show="showButtonAnaliseManual"
      )
        span.center
          i.fad.fa-exchange-alt
          b &nbsp {{ labelButtonAnaliseManual }}
    .btn
      el-button(
        type="success",
        @click="salvar",
        name="salvar",
        v-show="showButtonSalvar"
      )
        span.center
          i.fas.fa-save
          b &nbsp Salvar

      el-button(
        type="default",
        @click="download",
        name="download",
        v-show="showButtonDownload"
      )
        span.center
          b Download PDF &nbsp
          i.fa.fa-download

      el-button(
        :disabled="disabledButtonProximo"
        type="default",
        @click="proximo",
        name="proximo",
        v-show="!isUltimoPasso && showButtonProximo"
      )
        div.center
          b Próximo &nbsp
          i.fas.fa-chevron-right

      el-button(
        type="primary",
        @click="finalizar",
        name="finalizar",
        v-show="(isUltimoPasso && showButtonFinalizar) || isDespacho"
      )
        span.center
          i.fa.fa-check
          b &nbsp {{ finalizarLabel }}
      el-button(
        type="primary",
        @click="enviar",
        name="enviar",
        v-show="showButtonEnviar"
      )
        span.center
          i.fa.fa-share-square
          b &nbsp Enviar
</template>

<script>
export default {
  props: {
    isPrimeiroPasso: {
      type: Boolean,
      default: false
    },

    isUltimoPasso: {
      type: Boolean,
      default: false
    },

    showButtonSalvar: {
      type: Boolean,
      default: false
    },

    isEtapaSalva: {
      type: Boolean,
      default: true
    },

    showButtonCancelar: {
      type: Boolean,
      required: false,
      default: true
    },

    showButtonDownload: {
      type: Boolean,
      required: false,
      default: false
    },

    finalizarLabel: {
      type: String,
      required: false,
      default: 'Finalizar'
    },

    showButtonFinalizar: {
      type: Boolean,
      required: false,
      default: true
    },

    showButtonEnviar: {
      type: Boolean,
      required: false,
      default: false
    },

    cancelarLabel: {
      type: String,
      required: false,
      default: 'Cancelar'
    },

    isIntroPasso: {
      type: Boolean,
      default: false
    },

    showButtonAnaliseManual: {
      type: Boolean,
      default: false
    },

    labelButtonAnaliseManual: {
      type: String,
      default: 'Análise Manual'
    },

    showButtonProximo: {
      type: Boolean,
      required: false,
      default: false
    },

    isDae: {
      type: Boolean,
      required: false,
      default: false
    },

    isDespacho: {
      type: Boolean,
      required: false,
      default: false
    },

    showButtonVoltar: {
      type: Boolean,
      required: false,
      default: true
    },

    disabledButtonProximo: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  methods: {
    salvar () {
      this.$emit('salvar')
    },

    voltarAba () {
      this.$emit('voltar')
    },

    cancelar () {
      this.$emit('cancelar')
    },

    proximo () {
      this.$emit('proximo')
    },

    enviar () {
      this.$emit('enviar')
    },

    finalizar () {
      this.$emit('finalizar')
    },

    download () {
      this.$emit('download')
    },

    changeAnalise () {
      this.$emit('changeAnalise')
    }
  }

}
</script>

<style scoped lang="scss">
.buttons {
  display: flex;
  justify-content: space-between;
  padding: 20px 10px 20px 10px;
}

.btn {
  display: flex;
}

.center {
  display: flex;
  align-items: center;
}

.icon {
  font-size: 16px;
}
.cancelarButton:hover,
.cancelarButton:focus {
  background-color: #fef0f0;
  color: #f56c6c;
  border-color: #fbc4c4;
}

@media (max-width: 780px) {
  .buttons {
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AppButtonsCadastro.vue